<template>
  <div style="white-space: pre-line;">
    <component v-if="component.length > 0" :is="component" :payload="componentPayload" @input="onPropsPass"></component>
    <div v-else>
      <p v-if="!isBlank" v-html="$sanitize(this.alert.content)"></p>
    </div>
  </div>
</template>
<script>
import FeedContentMorningRoutine from '@/components/FeedContentMorningRoutine'
import FeedContentEveningRoutine from '@/components/FeedContentEveningRoutine'
import NewLeadText from '@/components/NewLeadText'
import FeedContentVettedOffers from '@/components/FeedContentVettedOffers'
import FeedContentNewRegistration from '@/components/FeedContentNewRegistration'
import FeedContentFollowUpCompanies from '@/components/FeedContentFollowUpCompanies'
import FeedContentFollowUpPosition from '@/components/FeedContentFollowUpPosition'
import FeedContentFindNewCompanues from '@/components/FeedContentFindNewCompanues'
import FeedContentNewCompanyLead from '@/components/FeedContentNewCompanyLead'
import FeedContentSendCv from '@/components/FeedContentSendCv'
import FeedContentCompanyResponseCompanyProcess from '@/components/FeedContentCompanyResponseCompanyProcess'
import FeedContentReviewPosition from '@/components/FeedContentReviewPosition'
import PassValidator from '@/components/PassValidator'
import AlertContentSendCv from '@/components/AlertContentSendCv'

export default {
  name: 'FeedContent',
  components: {
    FeedContentMorningRoutine,
    FeedContentEveningRoutine,
    NewLeadText,
    FeedContentVettedOffers,
    FeedContentNewRegistration,
    FeedContentFollowUpCompanies,
    FeedContentFollowUpPosition,
    FeedContentFindNewCompanues,
    FeedContentNewCompanyLead,
    FeedContentSendCv,
    FeedContentCompanyResponseCompanyProcess,
    FeedContentReviewPosition,
    PassValidator,
    AlertContentSendCv
  },
  props: {
    alert: {
      type: Object
    }
  },
  data () {
    return {
      component: '',
      componentPayload: {},
      isBlank: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let content = this.alert.content
      let designator = this.alert.designator
      if (designator == 'morning_routine') {
        this.setComponent('FeedContentMorningRoutine', this.alert)
        return
      }
      if (designator == 'evening_routine') {
        this.setComponent('FeedContentEveningRoutine', this.alert)
        return
      }
      if (designator == 'new_lead') {
        this.setComponent('NewLeadText', this.alert.content)
        return
      }
      if (designator == 'new_company_lead') {
        this.setComponent('FeedContentNewCompanyLead', this.alert)
        return
      }
      if (['vetted_offers_key_words', 'vetted_offers'].includes(designator)) {
        this.setComponent('FeedContentVettedOffers', this.alert)
        return
      }
      if (['new_registration', 'new_registration_key_words'].includes(designator)) {
        this.setComponent('FeedContentNewRegistration', this.alert)
        return
      }
      if (designator == 'strong_offers') {
        this.setComponent('FeedContentVettedOffers', this.alert)
        return
      }
      if (['review_position', 'notice_position'].includes(designator)) {
        this.setComponent('FeedContentReviewPosition', this.alert)
        return
      }
      if (['designated_position'].includes(designator)) {
        return
      }
      if (['follow_up_position'].includes(designator)) {
        this.setComponent('FeedContentFollowUpPosition', this.alert)
        return
      }
      if (designator == 'follow_up_companies') {
        this.setComponent('FeedContentFollowUpCompanies', this.alert)
        return
      }
      if (designator == 'company_response_company_process') {
        this.setComponent('FeedContentCompanyResponseCompanyProcess', this.alert)
        return
      }
      if (designator == 'find_new_companies') {
        this.setComponent('FeedContentFindNewCompanues', this.alert)
        return
      }
      if (designator == 'send_cv' && this.alert.resources != undefined) {
        this.setComponent('AlertContentSendCv', this.alert)
        return
      }
      if (content != undefined && this.$utils.isStringJSON(content)) {
        this.jsonizeContent()
      }
    },
    onPropsPass (d) {
      this.$emit('input', d)
    },
    setComponent (component, payload) {
      this.component = component
      this.componentPayload = payload
    },
    jsonizeContent () {
      let parsed_content = JSON.parse(this.alert.content)
      let designator = this.alert.designator
      if (designator == 'position_offers_report') {
        this.component = 'PositionOffersReport'
        this.componentPayload = { resource: this.alert.resources.position, ...parsed_content }
        return
      }
      if (['applicant_creation_failed', 'position_creation_failed'].includes(designator)) {
        this.component = 'PassValidator'
        this.componentPayload = parsed_content
      }
    }
  }
}
</script>
